// Shared display helpers for the Sourcing tabs — tier/status/classification badges.
export const BROKERBIN_CONDITIONS = ['NEW', 'REF', 'USED', 'NOB', 'OEMREF', 'EXC', 'F/S', 'REP', 'ASIS'];

export const TIER_BADGE = {
  HOT: 'bg-red-600/15 text-red-600 border-red-600/30',
  WATCH: 'bg-amber-500/15 text-amber-600 border-amber-500/30',
  NORMAL: 'bg-muted text-muted-foreground border-transparent',
};

export const CLASSIFICATION_BADGE = {
  EXACT: 'bg-emerald-600/15 text-emerald-600 border-emerald-600/30',
  VARIANT: 'bg-sky-500/15 text-sky-600 border-sky-500/30',
  DROPPED: 'bg-muted text-muted-foreground border-transparent line-through',
};

export const DRAFT_STATUS_BADGE = {
  OPEN: 'bg-amber-500/15 text-amber-600 border-amber-500/30',
  SENT: 'bg-emerald-600/15 text-emerald-600 border-emerald-600/30',
  EXPIRED: 'bg-muted text-muted-foreground border-transparent',
  FAILED: 'bg-destructive/15 text-destructive border-destructive/30',
  TEST: 'bg-sky-500/15 text-sky-600 border-sky-500/30',
};

// "Top Vendors First" (29 Oct 2026) — vendor tier, from Zoho purchase history.
export const VENDOR_TIER_BADGE = {
  TOP: 'bg-emerald-600/15 text-emerald-600 border-emerald-600/30',
  REGULAR: 'bg-sky-500/15 text-sky-600 border-sky-500/30',
  PAST: 'bg-muted text-muted-foreground border-transparent',
  NEW: 'bg-amber-500/15 text-amber-600 border-amber-500/30',
  UNMATCHED: 'bg-muted text-muted-foreground border-transparent',
};

export const VENDOR_TIER_LABEL = {
  TOP: 'Top vendor',
  REGULAR: 'Regular',
  PAST: 'Past vendor',
  NEW: 'New',
  UNMATCHED: 'Not in Zoho',
};

// Phase 2 (learning) — RFQ outcome badges.
export const OUTCOME_BADGE = {
  QUOTED: 'bg-emerald-600/15 text-emerald-600 border-emerald-600/30',
  NO_STOCK: 'bg-muted text-muted-foreground border-transparent',
  DECLINED: 'bg-destructive/15 text-destructive border-destructive/30',
  NO_REPLY: 'bg-amber-500/15 text-amber-600 border-amber-500/30',
  PENDING: 'bg-sky-500/15 text-sky-600 border-sky-500/30',
};

// Per-SKU feedback spec (30 Oct 2026) — currencies offered for a line's quote.
export const SOURCING_CURRENCIES = ['USD', 'EUR', 'GBP', 'CNY', 'HKD', 'JPY', 'SGD'];

export function badgeClass(map, key) {
  return map[key] || 'bg-muted text-muted-foreground border-transparent';
}
